import { defineComponent as _defineComponent } from 'vue'
import type { Keyword } from '@ilteducation/content-ref-data-types';
import { ref } from 'vue';

type Props = {
  value: string[];
  items?: Keyword[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Keywords',
  props: {
    value: null,
    items: null
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'input', keywords: string[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: string[];
  items?: Keyword[];
}





const searchstring = ref('');

const removeKeyword = (id: string) => {
  emits(
    'input',
    props.value.filter((keywordId) => keywordId !== id),
  );
};

return { __sfc: true,props, emits, searchstring, removeKeyword }
}

})